<template>
  <v-container>
    <v-row v-if="remainingExchangetransactions.length === 0">
      <v-col>
        <div>
          {{ $t('exchange.NoTransactions') }}
        </div>
      </v-col>
    </v-row>
    <v-row v-for="transaction in remainingExchangetransactions" :key="transaction.transaction._id">
      <v-col v-if="transaction.transaction.type === constants.FACTORING_PAYMENT_METHODS.OPEN_BANKING" cols="12" style="text-align: right;align-self: center">
        <!-- Give bytos to the user -->
        {{ transaction.stripe }}
        <v-card-text>
          <form>
            <h3>Amount: <span>{{ transaction.transaction.amountReceive }}</span></h3>
            <v-btn class="btn-primary" dark @click="payTransactionCrypto(transaction.user.walletAddress, transaction.transaction.amountReceive, transaction.transaction._id)">
              {{ $t('Pay with crypto') }}
            </v-btn>
          </form>
        </v-card-text>
      </v-col>
      <v-col v-if="transaction.transaction.type === constants.FACTORING_PAYMENT_METHODS.CRYPTO" cols="12" style="text-align: right;align-self: center">
        <PaymentComponent :amount="transaction.transaction.amountReceive" :id-form="'Form'+transaction.transaction._id" :id-card="'Card'+transaction.transaction._id" :id-btn="'Btn'+transaction.transaction._id" :user="transaction.user" @success="onSuccessTransaction(transaction.transaction._id)" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Constants from "../../constants";
import ApiRepository from "@/repositories/ApiRepository";
import PaymentComponent from "../components/Payment";
import SmartRepository from "@/repositories/SmartRepository";

export default {
    name: "PayExchangeTransactions",
    components: {PaymentComponent},
    data () {
        return {
            remainingExchangetransactions: [],
            isAdmin: false,
            constants: Constants,
            platformAccounts: null,
            payStripe: false,
            exangeRatios: null,
            amountEur: 0,
            amountBytos: 0
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            ApiRepository.getRemainingTransactions().then((transactions) => {
                console.log(transactions.data.transactions);
                this.remainingExchangetransactions = transactions.data.transactions;
            });
            ApiRepository.getExangeRatios().then((ratios) => {
                this.exangeRatios = ratios.data.exangeRatios;
            });
            ApiRepository.getPlatformPublicAccounts().then((accounts) => {
                this.platformAccounts = accounts.data.accounts;
            });
        },
        getNumber (val) {
            return val.toFixed(2);
        },
        payCrypto (wallet, amount) {
            SmartRepository.transaction(Constants.contractByto, "transfer", [wallet, SmartRepository.parseEther(amount)]).then(() => {
                this.onSuccess(Constants.FACTORING_PAYMENT_METHODS.CRYPTO, amount, this.getNumber(this.amountBytos / this.exangeRatios.eurToByto));
            }).catch((err) => {
                console.log("ERROR: " + err);
                this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
            });
        },
        onSuccessTransaction (id) {
            ApiRepository.updateTransaction(id).then(() => {
                this.$root.$emit('show-snackbar', {message: this.$t('Payed correctly')});
                this.fetch();
            });
        },
        onSuccess (type, amountPayed, amountReceive) {
            ApiRepository.addExchangeTransaction(type, amountPayed, amountReceive).then(() => {
                this.$root.$emit('show-snackbar', {message: this.$t('Payed correctly')});
                this.payStripe = false;
                this.amountEur = 0;
                this.amountBytos = 0;
            });
        },
        payTransactionCrypto (wallet, amount, id) {
            SmartRepository.transaction(Constants.contractByto, "transfer", [wallet, SmartRepository.parseEther(amount)]).then(() => {
                this.onSuccessTransaction(id);
            }).catch((err) => {
                console.log("ERROR: " + err);
                this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
            });
        },
    }
};
</script>

<style scoped>

</style>
